module.exports = __webpack_public_path__ + "img/img_futa_flower_lace.a45d03ca.png";